import React from "react";
import {
  Box,
  Typography,
  Chip,
  Button,
  Paper,
  Stack,
  Divider,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import ImageUpload from "../../image-upload";
import { useJobCompletion } from "../../../JobCompletionContext";

const font = { fontFamily: "Poppins" };
const grayChip = {
  backgroundColor: "#E9E9E9",
  borderRadius: "20px",
  fontSize: "14px",
  fontWeight: 500,
};

const CompleteJobs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const job = location.state;
  const { completedJobs, updateCache } = useJobCompletion();

  const isJobDone = (jobName) => {
    console.log("job.r", job.r);
    const status = job.r?.[jobName] || "";
    console.log("status", status);
    const fromSheet = status === "Completed" || status === "";
    const fromCache = completedJobs.has(jobName);
    console.log(jobName, fromSheet, fromCache);
    return fromSheet || fromCache;
  };

  console.log("complete-job", job);

  return (
    <Box
      sx={{
        ...font,
        width: "100%",
        maxWidth: 500,
        margin: "0 auto",
        minHeight: "100vh",
      }}
    >
      <Paper elevation={1} sx={{ p: 2 }}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            <Typography variant="h6" fontWeight={700}>
              {job.address}
            </Typography>
            <Typography variant="body1">{job.cityState}</Typography>
          </Box>
          <Stack spacing={1} alignItems="flex-end">
            <Chip label={`Stop ${job.stopNumber}`} sx={grayChip} />
            <Chip label={job.size} sx={grayChip} />
          </Stack>
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Job Cards */}
        <Stack spacing={3}>
          {job.jobs.map((jobName, idx) => {
            const isCompleted = isJobDone(jobName);
            return (
              <Paper
                key={idx}
                elevation={0}
                sx={{
                  borderRadius: "15px",
                  p: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: "#F9F9F9",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    fontFamily: "Poppins",
                  }}
                >
                  {jobName}
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#00C23C",
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                    px: 3,
                    py: 1,
                    borderRadius: "10px",
                    "&:hover": {
                      backgroundColor: "#00A830",
                    },
                  }}
                  onClick={() =>
                    navigate("/webcam-capture-landscaping", {
                      state: {
                        service: jobName,
                        addressLong: job.addressLong,
                        address: job.address,
                        driver: job.driver,
                        script_id: job.script_id,
                        image_upload_path: job.image_upload_path,
                      },
                    })
                  }
                >
                  {isCompleted ? "Done" : "Complete Job"}
                </Button>
              </Paper>
            );
          })}
        </Stack>
      </Paper>
    </Box>
  );
};

export default CompleteJobs;
